import { render, staticRenderFns } from "./SupplierProfileDetailsView.vue?vue&type=template&id=5c0e6626&"
import script from "./SupplierProfileDetailsView.vue?vue&type=script&lang=js&"
export * from "./SupplierProfileDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./SupplierProfileDetailsView.vue?vue&type=style&index=0&id=5c0e6626&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports